// @module NXTurn.ShoppingExtensions.NewArrivals
define('C3.ShoppingExtensions.PDP.SetsIncluded.Item.Collection'
,	[
	   'Item.Collection'	
    ]
, function (
	ItemCollection
)
{
    'use strict';

	// @class NXTurn.ShoppingExtensions.NewArrivals.View @extends Backbone.View
	return ItemCollection.extend({
    initialize: function(options) {
       // this.searchApiMasterOptions = Configuration.searchApiMasterOptions.correlatedItems;
       this.searchApiMasterOptions= {
        fieldset : 'details'
       }
       // console.log(options)
        /*this.itemsIds = _.isArray(options.itemsIds)
            ? _.sortBy(options.itemsIds, function(id) {
                  return id;
              })
            : [options.itemsIds];
        this.responseResults =  _.isArray(options.responseResults)
            ? _.sortBy(options.responseResults, function(id) {
                  return id;
              })
            : [options.responseResults];*/ 
        this.itemsIds = options.itemsIds;
        this.responseResults = options.responseResults;      
    },

    // @method fetchItems @return {jQuery.Deferred}
    fetchItems: function() {
        //console.log(this.itemsIds)
        return this.fetch({ data: { id: this.itemsIds.join(',') } });
    },

    // http://backbonejs.org/#Model-parse
    parse: function(response) {
        const original_items = _.compact(response.items) || [];
        const self = this;
        var items = [];

       // console.log(this.itemsIds);
       // console.log(original_items);

       var selector_data = []
         _.each(this.itemsIds, function(ids) {

            selector_data = _.find(original_items, function(obj) {
                return obj.internalid == ids;
            });
            items.push(selector_data)
          });
         
        // console.log(_.compact(items));
         var final_items = _.compact(items)

        //return _.toArray(original_items);
        return _.toArray(final_items);
    }

	});
});
